import { render } from "./NonPlanTrakingHistory.vue?vue&type=template&id=1667a2d2"
import script from "./NonPlanTrakingHistory.vue?vue&type=script&lang=js"
export * from "./NonPlanTrakingHistory.vue?vue&type=script&lang=js"

import "./NonPlanTrakingHistory.vue?vue&type=style&index=0&id=1667a2d2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__